import DesktopWindowsRoundedIcon from '@material-ui/icons/DesktopWindowsRounded';
import CategoryRoundedIcon from '@material-ui/icons/CategoryRounded';
import ComputerRoundedIcon from '@material-ui/icons/ComputerRounded';
import EmojiPeopleRoundedIcon from '@material-ui/icons/EmojiPeopleRounded';
import WbIncandescentRoundedIcon from '@material-ui/icons/WbIncandescentRounded';
import TabRoundedIcon from '@material-ui/icons/TabRounded';
import TabletAndroidRoundedIcon from '@material-ui/icons/TabletAndroidRounded';

export const SidebarData1 = [
    {
        icon:DesktopWindowsRoundedIcon,
        heading:"Demo Test",
        heading2:"Demo Test"
    },
    {
        icon:CategoryRoundedIcon,
        heading:"Practice Test",
        heading2:"Practice Test"
    },
    {
        icon:ComputerRoundedIcon,
        heading:"Main Test",
        heading2:"Main Test"
    }
]


export const SidebarData2 = [
    {
        icon:EmojiPeopleRoundedIcon,
        heading:"Counselling",
        heading2:"Counselling"
    }
    ,
    {
        icon:WbIncandescentRoundedIcon,
        heading:"Mentorship",
        heading2:"Mentorship"
    }
    

]


export const SidebarData3= [

    {
        icon:TabRoundedIcon,
        heading:"Subscribe",
        heading2:"Subscribe"
    }
    ,
    {
        icon:TabletAndroidRoundedIcon,
        heading:"Contact Us",
        heading2:"Contact Us"
    }

]